// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"1bdea5b5","552":"7cf66516"}[chunkId] + ".chunk.css";
};